<template>
    <div class="optpl-templates__group-container">
        <h3 class="opui-mb-4">
            <span>
                {{ group.title || 'Related Templates' }}
            </span>
        </h3>

        <div class="optpl-templates__related-list" v-if="group.items && group.items.length" :class="{ 'optpl-templates__list-purchasable': group.purchasable }">
            <ul>
                <li v-for="item in group.items">
                    <TemplateItem
                        :template="item"
                        :showUpgrade="locked"
                        :showDetails="showDetails"
                        :purchaseLink="purchaseLink"
                        :purchaseText="purchaseText"
                    />
                </li>
            </ul>
        </div>

        <div v-else>
            <NoResults />
        </div>
    </div>
</template>

<script>
import TemplateItem from './TemplateItem.vue';
import NoResults from "./NoResults.vue";

export default {
    components: { TemplateItem, NoResults },
    props: {
        group:       { type: Object, required: true },
        locked:      { type: Boolean, default: false },
        showDetails: { type: Boolean, default: true },
        purchaseLink: { type: String, default: '' },
        purchaseText: { type: String, default: '' },
    },
    data() {
        return {
            loading: false,
        }
    },
}
</script>
